import { render } from "./roomcash_hotel_search.vue?vue&type=template&id=af941734"
import script from "./roomcash_hotel_search.vue?vue&type=script&lang=js"
export * from "./roomcash_hotel_search.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__